/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedDocRejectRequest } from '../types/PatchedDocReject';
import type { DocRejectResponse } from '../types/DocReject';

export type CrossWorkerDocsRejectPartialUpdateRequest = PatchedDocRejectRequest;
export type CrossWorkerDocsRejectPartialUpdateResponse = DocRejectResponse;

export type CrossWorkerDocsRejectPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/cross_worker_docs/{id}/reject/
 *
 * ```yaml
 * operationId: cross_worker_docs_reject_partial_update
 * tags:
 *   - cross_worker_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocReject'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocReject'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocReject'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DocReject'
 *     description: ''
 * ```
 */
export const crossWorkerDocsRejectPartialUpdateOperation = ({
  id,
  ...rest
}: CrossWorkerDocsRejectPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/cross_worker_docs/${id}/reject/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/cross_worker_docs/{id}/reject/' };
  };

/**
 * PATCH /dmx-server/cross_worker_docs/{id}/reject/
 *
 * ```yaml
 * operationId: cross_worker_docs_reject_partial_update
 * tags:
 *   - cross_worker_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocReject'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocReject'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocReject'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DocReject'
 *     description: ''
 * ```
 */
export const crossWorkerDocsRejectPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: CrossWorkerDocsRejectPartialUpdateQuery;
  request: PatchedDocRejectRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DocRejectResponse>> => {
  const operation = crossWorkerDocsRejectPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
